import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const DynamicLink = (props)=>{
    const { href, children, ...rest } = props;
    const [LinkComponent, setLinkComponent] = __WEBPACK_EXTERNAL_MODULE_react__["default"].useState(null);
    __WEBPACK_EXTERNAL_MODULE_react__["default"].useEffect(()=>{
        let isMounted = true;
        import("next/link").then((NextLink)=>{
            if (isMounted) setLinkComponent(()=>NextLink.default);
        }).catch((e)=>{
            setLinkComponent(null);
        });
        return ()=>{
            isMounted = false;
        };
    }, []);
    if (LinkComponent) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(LinkComponent, {
        href: href,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("a", {
            ...rest,
            children: children
        })
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("a", {
        href: "string" == typeof href ? href : href.href,
        ...rest,
        children: children
    });
};
export { DynamicLink };
